export const initialState = {
  dataAdmin: [],
  isLoading: false,
  isError: false,
  msg: '',
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'Fetch_Admin':
      return {
        ...state,
        isLoading: true,
        isFetching: true,
      };
    case 'Fetch_Admin_Success':
      return {
        ...state,
        dataAdmin: action.data,
        isFetching: false,
      };
    case 'Fetch_Admin_Failed':
      return {
        ...state,
        isError: true,
        isLoading: false,
        isFetching: false,
        msg: action.msg,
      };
    case 'Delete_Admin_Success':
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
};
